module.exports = {
      rootPath: 'https://www.colivar.com',
    };


// WEBPACK FOOTER //
// external "{/n      rootPath: 'https:/www.colivar.com',/n    }"